import { h } from 'preact';
import { SelectEntry, CheckboxEntry } from '@epx/flow';

const TASK_TYPES = ['epx:UserTask', 'epx:ManualTask'];

const getAssignToOptions = (i18n) => [
  { value: '', label: i18n['opt.none'] || '-- None --' },
  { value: 'Creator', label: i18n['opt.Creator'] || 'Creator' },
  { value: 'Sender', label: i18n['opt.Sender'] || 'Sender' },
  { value: 'Recipients', label: i18n['opt.Recipients'] || 'Recipients' },
];

export class SfdDocumentManagementPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return TASK_TYPES.includes(elementType);
  }

  getGroups(element) {
    const lf = this._lf;
    const i18n = this._i18n;
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    return [
      {
        id: 'documentManagement',
        label: i18n.documentManagement || 'Document Management',
        entries: [
          {
            id: 'assignTo',
            component: () => (
              <SelectEntry
                id="sfd-assignTo"
                label={i18n.assignTo || 'Assign To'}
                value={props.assignTo || ''}
                options={getAssignToOptions(i18n)}
                onChange={(val) => update('assignTo', val)}
              />
            ),
          },
          {
            id: 'linkDocumentExpedient',
            component: () => (
              <CheckboxEntry
                id="sfd-linkDocumentExpedient"
                label={i18n.linkDocumentExpedient || 'Link Document Expedient'}
                checked={props.linkDocumentExpedient === true || props.linkDocumentExpedient === 'true'}
                onChange={(val) => update('linkDocumentExpedient', val)}
              />
            ),
          },
          {
            id: 'linkAttachmentExpedient',
            component: () => (
              <CheckboxEntry
                id="sfd-linkAttachmentExpedient"
                label={i18n.linkAttachmentExpedient || 'Link Attachment Expedient'}
                checked={props.linkAttachmentExpedient === true || props.linkAttachmentExpedient === 'true'}
                onChange={(val) => update('linkAttachmentExpedient', val)}
              />
            ),
          },
          {
            id: 'sendersAssignment',
            component: () => (
              <CheckboxEntry
                id="sfd-sendersAssignment"
                label={i18n.sendersAssignment || 'Senders Assignment'}
                checked={props.sendersAssignment === true || props.sendersAssignment === 'true'}
                onChange={(val) => update('sendersAssignment', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
